<template>
  <footer class="background-primary mt-5 text-white">
    <div class="row">
      <div class="col-10 offset-1">
        <div class="row align-items-center">
          <div class="col-xl-2 col-lg-3 col-md-4 d-none d-md-block px-5">
            <router-link v-bind:to="{ name: 'index' }">
              <img src="/static/images/logo.png" class="img-fluid" />
            </router-link>
          </div>
          <div class="col-xl-10 col-lg-9 col-md-8 col-sm-12">
            <h3 class="font-weight-bold">Kontak</h3>
            <div class="row">
              <div v-for="(branch, index) in branches" v-if="!branch.isHidden" v-bind:key="branch.id || index" class="col-auto">
                <h4 class="font-weight-bold mb-0">{{ branch.name }}</h4>
                <p v-if="getPhone(branch.address)" class="small">{{ getPhone(branch.address) }}</p>
              </div>           
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
	data() {
    return {
      branches: []
    };
  },
  methods: {
    fetchData() {
      this.axios.get(process.env.API_URL + '/branch', {params: {isHidden: false}}).then(response => {
        this.branches = response.data.data.filter(branch => branch.isPrimary);
      });
    },
    getPhone(address) {
      if (!address) return '';
      const match = address.match(/\(021\)\s?[\d\s\-]+/);
      return match ? match[0].trim() : '';
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style scoped>
footer {
  padding: 20px;
  min-height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/Footer.vue